import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <section className="bg-background-50 pt-32 md:pt-44 pb-24 min-h-[70vh] flex items-center">
      <div className="max-w-editorial mx-auto px-4 md:px-8 w-full text-center">
        <span className="font-heading text-6xl md:text-8xl font-black text-background-300 select-none">
          404
        </span>
        <h1 className="mt-6 font-heading text-2xl md:text-3xl font-bold text-foreground-950">
          这个页面不存在
        </h1>
        <p className="mt-3 text-sm md:text-base text-foreground-600">
          链接可能已经失效，或被当事人申请撤下。
        </p>
        <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center">
          <Link
            to="/"
            className="inline-flex items-center justify-center gap-2 px-5 py-3 rounded-md text-sm font-medium whitespace-nowrap cursor-pointer bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors"
          >
            <i className="ri-home-4-line"></i>
            返回首页
          </Link>
          <Link
            to="/stories"
            className="inline-flex items-center justify-center gap-2 px-5 py-3 rounded-md text-sm font-medium whitespace-nowrap cursor-pointer border border-background-300 text-foreground-800 hover:border-primary-400 hover:text-primary-600 transition-colors"
          >
            <i className="ri-book-open-line"></i>
            浏览亲述档案
          </Link>
        </div>
      </div>
    </section>
  );
}